/**
 * Builds a safe CSS `url("...")` value. Returns "none" when the value uses a
 * scheme other than http(s), data:image/* or a relative path.
 */
export function cssUrl(value: string | null | undefined): string {
  const raw = (value ?? "").trim();
  if (!raw) return "none";
  const scheme = /^([a-zA-Z][a-zA-Z0-9+.-]*):/.exec(raw)?.[1]?.toLowerCase();
  const ok = scheme
    ? scheme === "http" || scheme === "https" || /^data:image\//i.test(raw)
    : true;
  if (!ok) return "none";
  const escaped = raw
    .replace(/\\/g, "\\\\")
    .replace(/"/g, '\\"')
    .replace(/\r?\n|\r|\f/g, "")
    .replace(/[()]/g, (c) => `\\${c}`);
  return `url("${escaped}")`;
}
